var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehiclePoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.9088,
    cy: 25.9088,
    r: 20.7403,
    transform: "rotate(-14.6012 25.9088 25.9088)",
    fill: "white",
    stroke: "#18181B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9102 16.9088V31.0533L34.5352 34.9088L25.9102 16.9088Z",
    fill: "#00CB50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9102 16.9088V31.0533L17.2852 34.9088L25.9102 16.9088Z",
    fill: "#06800A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiclePoint);
export default __webpack_public_path__ + "static/media/vehicle-point.28503a647ad00058a0fa6d86d8a37a2f.svg";
export { ForwardRef as ReactComponent };